module.exports = __webpack_public_path__ + "img/betmode_toto_nfl.2bb2ff37.png";